<script setup>
import { ChevronDownIcon, EyeIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { useRoute } from "@js/utils/route";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { tenantId, row } = defineProps({
  tenantId: {
    type: String,
    required: false,
  },
  row: {
    type: Object,
    required: true,
  },
});

const { route } = useRoute();
</script>

<template>
  <div class="flex h-full items-center gap-2 p-4">
    <ActionButton
      v-if="!!tenantId"
      size="small"
      type="primary"
      class="size-8"
      :title="t('button.see')"
      :href="
        route('front.projectManagement.seo.positionTracking', {
          tenant: row.original.tenant.id,
        })
      "
      :icon="EyeIcon"
    />
    <div v-else class="size-8">&nbsp;</div>

    <ActionButton
      v-if="row.getCanExpand() && row.original.children?.length > 0"
      size="small"
      type="secondary"
      class="size-8"
      :title="row.getIsExpanded() ? t('button.collapse') : t('button.expand')"
      :callback="() => row.toggleExpanded()"
    >
      <ChevronDownIcon
        class="size-5 flex-shrink-0 duration-150"
        :class="{ 'rotate-180 transform': row.getIsExpanded() }"
      />
    </ActionButton>
    <div v-else class="size-8">&nbsp;</div>
  </div>
</template>
